import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { SurveillanceValuesProps } from './SurveillanceValues.types';
import { getSurveillanceValuesAsArray } from '../utils/getSurveillanceValuesAsArray';
import { RootState } from 'FRONTEND/reducers/types';


const SurveillanceValues = ({
  surveillanceEvent,
  surveillanceEventHistory,
  currentForm,
  medicineList,
  dense,
}: SurveillanceValuesProps) => {
  const currentLang = useSelector((state: RootState) => state.user.locale);
  const { notDeletedValues, deletedValues } = getSurveillanceValuesAsArray({
    surveillanceEvent,
    surveillanceEventHistory, // individual MCSurveillanceModificationRecord (same structure as surveillanceEvent.values)
    currentForm,
    medicineList,
    currentLang,
  });

  const isDeleted = surveillanceEvent?.deletedByUser;

  const allValues = [
    ...notDeletedValues.map(item => ({ ...item, deleted: isDeleted })),
    ...deletedValues.map(item => ({ ...item, deleted: true })),
  ];

  return (
    <>
      {allValues.map(({ label, value, qualifier, unit, deleted }, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Typography
            component='span'
            sx={{
              textDecoration: deleted ? 'line-through' : '',
              fontSize: dense ? '12px' : 'inherit',
            }}
          >
            {label}
          </Typography>

          {value ? (
            <Typography
              component='span'
              sx={{
                fontWeight: 'bold',
                textDecoration: deleted ? 'line-through' : '',
                fontSize: dense ? '12px' : 'inherit',
                marginLeft: '8px',
              }}
            >
              {qualifier ? `${qualifier} ` : ''}{value}
              {unit ? ` ${unit}` : ''}
            </Typography>
          ) : null}
        </Box>
      ),
      )}
    </>
  );
};

export default SurveillanceValues;
